export const ModalChangePhotoTranslationsCs = {
  addPhoto: 'Přidat fotografii',
  textPlaceholder: 'Napište svou zprávu...',
};
